
import { PythonCourse } from './types';
import { 
  PYTHON_BASICS_MODULE, 
  PYTHON_CONTROL_FLOW_MODULE, 
  PYTHON_FUNCTIONS_MODULE,
  PYTHON_DATA_STRUCTURES_MODULE,
  PYTHON_BUILTIN_LIBRARIES_MODULE
} from './essentialsModules';
import {
  PYTHON_OOP_BASICS_MODULE,
  PYTHON_ADVANCED_OOP_MODULE,
  PYTHON_FILE_HANDLING_MODULE,
  PYTHON_API_INTEGRATION_MODULE
} from './intermediateModules';
import { 
  PYTHON_EXCEPTION_HANDLING_MODULE,
  PYTHON_FILE_OPERATIONS_MODULE,
  PYTHON_PROJECT_ORGANIZATION_MODULE
} from './essentialsExpandedModules';
import {
  PYTHON_ADVANCED_DATA_STRUCTURES_MODULE,
  PYTHON_REGEX_MODULE,
  PYTHON_DATABASE_BASICS_MODULE,
  PYTHON_TESTING_MODULE
} from './intermediateExpandedModules';
import { PYTHON_ADVANCED_MASTERY_TRACK } from './advancedTrack';

// Track 1: Python Essentials (Enhanced Beginner) - Now with 8 modules
export const PYTHON_ESSENTIALS_TRACK: PythonCourse = {
  id: "python-essentials",
  title: "Python Essentials",
  description: "Master the essential concepts of Python programming. Learn variables, data types, control flow, functions, and data structures to build a solid foundation for Python development.",
  level: "beginner",
  estimatedHours: 13,
  totalDuration: "13 hours",
  durationHours: 13,
  modules: [
    PYTHON_BASICS_MODULE,
    PYTHON_CONTROL_FLOW_MODULE,
    PYTHON_FUNCTIONS_MODULE,
    PYTHON_DATA_STRUCTURES_MODULE,
    PYTHON_BUILTIN_LIBRARIES_MODULE,
    PYTHON_EXCEPTION_HANDLING_MODULE,
    PYTHON_FILE_OPERATIONS_MODULE,
    PYTHON_PROJECT_ORGANIZATION_MODULE
  ],
  prerequisites: [
    "Basic computer literacy",
    "No prior programming experience required",
    "Access to a computer with internet connection"
  ],
  learningOutcomes: [
    "Understand Python syntax and basic programming concepts",
    "Create and manipulate variables and different data types",
    "Use conditional statements and loops for program control",
    "Write and call functions with parameters and return values",
    "Work with Python data structures (lists, dictionaries, tuples)",
    "Utilize Python's built-in libraries effectively",
    "Handle exceptions and errors gracefully",
    "Perform file operations and data persistence",
    "Organize code into modules and packages",
    "Apply best practices for Python code organization",
    "Debug and troubleshoot common Python errors",
    "Build a complete CLI Calculator project"
  ],
  tags: ["python", "programming", "basics", "fundamentals", "beginner", "essentials"],
  objectives: [
    "Understand Python syntax and basic programming concepts",
    "Create and manipulate variables and different data types",
    "Use conditional statements and loops for program control",
    "Write and call functions with parameters and return values",
    "Work with Python data structures (lists, dictionaries, tuples)",
    "Utilize Python's built-in libraries effectively",
    "Handle exceptions and errors gracefully",
    "Perform file operations and data persistence",
    "Organize code into modules and packages",
    "Apply best practices for Python code organization",
    "Debug and troubleshoot common Python errors",
    "Build a complete CLI Calculator project"
  ]
};

// Track 2: Intermediate Python & OOP - Now with 8 modules
export const PYTHON_INTERMEDIATE_OOP_TRACK: PythonCourse = {
  id: "python-intermediate-oop",
  title: "Intermediate Python & Object-Oriented Programming",
  description: "Advance your Python skills with object-oriented programming, advanced data structures, databases, and testing. Build real-world applications with professional development practices.",
  level: "intermediate",
  totalDuration: "17 hours",
  durationHours: 17,
  modules: [
    PYTHON_OOP_BASICS_MODULE,
    PYTHON_ADVANCED_OOP_MODULE,
    PYTHON_FILE_HANDLING_MODULE,
    PYTHON_API_INTEGRATION_MODULE,
    PYTHON_ADVANCED_DATA_STRUCTURES_MODULE,
    PYTHON_REGEX_MODULE,
    PYTHON_DATABASE_BASICS_MODULE,
    PYTHON_TESTING_MODULE
  ],
  prerequisites: [
    "Completion of Python Essentials track or equivalent knowledge",
    "Understanding of basic Python syntax and functions",
    "Familiarity with Python data types and control structures"
  ],
  learningOutcomes: [
    "Master object-oriented programming concepts in Python",
    "Design and implement classes with proper encapsulation",
    "Handle file operations and data persistence",
    "Work with external APIs and web services",
    "Understand inheritance, polymorphism, and abstraction",
    "Use advanced data structures and collections efficiently",
    "Master regular expressions for text processing",
    "Work with databases using SQLite and SQL",
    "Implement comprehensive testing strategies",
    "Apply test-driven development practices",
    "Implement error handling and exception management",
    "Use virtual environments and package management",
    "Build a complete File Organizer Bot project"
  ],
  tags: ["python", "intermediate", "oop", "object-oriented", "databases", "testing", "professional"],
  objectives: [
    "Master object-oriented programming concepts in Python",
    "Design and implement classes with proper encapsulation",
    "Handle file operations and data persistence",
    "Work with external APIs and web services",
    "Understand inheritance, polymorphism, and abstraction",
    "Use advanced data structures and collections efficiently",
    "Master regular expressions for text processing",
    "Work with databases using SQLite and SQL",
    "Implement comprehensive testing strategies",
    "Apply test-driven development practices",
    "Implement error handling and exception management",
    "Use virtual environments and package management",
    "Build a complete File Organizer Bot project"
  ]
};

// Track 3: Python Advanced Mastery - New comprehensive advanced track
export { PYTHON_ADVANCED_MASTERY_TRACK };
